import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';

import TiptapChip from '@plugins/tiptap/components/TiptapChip.vue';

export const css = `
.tiptap-chip {
    display: inline;
}
`;

export default Node.create({
    name: 'Chip',
    content: '',
    marks: '',
    group: 'inline',
    inline: true,
    defining: false,
    atom: true,

    addNodeView() {
        return VueNodeViewRenderer(TiptapChip);
    },

    addAttributes() {
        return {
            text: { default: 'Chip' },
            type: { default: 'primary' },
            prefix: { default: null },
            icon: { default: null },
            size: { default: 'large' },
            bold: { default: false },
            solid: { default: false },
            dark: { default: false }
        };
    },

    addCommands() {
        return {
            insertChip:
                attrs =>
                ({ commands }) => {
                    return commands.insertContent({ type: this.name, attrs: attrs || {} });
                }
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span.tiptap-chip',
                getAttrs: node => ({
                    text: node.getAttribute('data-text'),
                    type: node.getAttribute('data-type'),
                    prefix: node.getAttribute('data-prefix'),
                    icon: node.getAttribute('data-icon'),
                    size: node.getAttribute('data-size'),
                    bold: node.getAttribute('data-bold') === 'true',
                    solid: node.getAttribute('data-solid') === 'true',
                    dark: node.getAttribute('data-dark') === 'true'
                })
            }
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            {
                class: 'tiptap-chip',
                'data-text': HTMLAttributes.text,
                'data-type': HTMLAttributes.type,
                'data-prefix': HTMLAttributes.prefix,
                'data-icon': HTMLAttributes.icon,
                'data-size': HTMLAttributes.size,
                'data-bold': HTMLAttributes.bold ? 'true' : null,
                'data-solid': HTMLAttributes.solid ? 'true' : null,
                'data-dark': HTMLAttributes.dark ? 'true' : null
            }
        ];
    }
});
